/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcMutualfundsV1DividendAccrualEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_MUTUALFUNDS_V1_DIVIDEND_ACCRUAL_EVENT_ENTITY_NAME = 'ixc.mutualfunds.v1.DividendAccrualEvent';
export const ixcMutualfundsV1DividendAccrualEventEntity = new schema.Entity<IxcMutualfundsV1DividendAccrualEvent>(IXC_MUTUALFUNDS_V1_DIVIDEND_ACCRUAL_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcMutualfundsV1DividendAccrualEvent) => `${entity.metadata?.eventId}` });

